/**
 * Setor ativo (o "tenant" em que o usuário está operando) persistido em
 * localStorage. Mora aqui, e não no `UserSectorProvider`, porque o interceptor do
 * axios precisa ler o valor fora do React (ver `core/api/axios/index.ts`) —
 * importar o provider de lá arrastaria React pra dentro da camada de HTTP.
 *
 * Contrato (SA-1277): TODA escrita do setor ativo passa por `writeActiveSectorId`.
 * O backend autoriza chat/campanha comparando o setor do recurso com este valor,
 * então um setor em memória que não esteja aqui vira 403 nessas rotas.
 */
export const ACTIVE_SECTOR_LS_KEY = "superagents.activeSectorId.v1";

/** Header em que a request declara o setor ativo (ver `verify-sector-access.ts`). */
export const ACTIVE_SECTOR_HEADER = "x-active-sector";

export function readActiveSectorId(): string | null {
  try {
    return localStorage.getItem(ACTIVE_SECTOR_LS_KEY);
  } catch {
    return null;
  }
}

export function writeActiveSectorId(id: string): void {
  try {
    localStorage.setItem(ACTIVE_SECTOR_LS_KEY, id);
  } catch {
    /* localStorage indisponível */
  }
}
